import { api } from "@/lib/api";

// First-party shopping analytics: product_view, add_to_cart, begin_checkout, purchase.
export const track = (type, data = {}) => {
  api.post("/events", { type, ...data }).catch(() => {});
};
